import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import {CommonService} from '../../services/CommonService';

import { APIResponse } from '../types/Common';


const common = createSlice({
    name: 'common',
    initialState: {
        common: {},
        partner: [],
        bankList:[],
        sampleCsv : [],
        agencyList:[]
    },
    reducers: {
        config: (state, action) => {
            state.common = action.payload;
        },

        partner: (state, action) => {
            state.partner = action.payload;
        },
        bankList: (state, action) => {
            state.bankList = action.payload;
        },
        setSampleCsv: (state, action) => {
            state.sampleCsv = action.payload
        },
        agencyList: (state, action) => {
            state.agencyList = action.payload;
        },
    },
});

export default common.reducer;

const { config, partner,bankList,setSampleCsv,agencyList } = common.actions


export const getMasterConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getMasterConfig().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(config(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getPartnerList = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getPartnerList().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(partner(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getBankList = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getBankList().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(bankList(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const addDocument = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.addDocument(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                resolve(response.data)

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

// import uploadSoaCsv

export const uploadSoaCsv = async (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.uploadSoaCsv(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

/* * Function to make API call to fetch data from BULK UPLOAD LOGS
 * @param params 
 * @returns 
 */
export const getBulkUploadCsvLogs = () => {
    return new Promise((resolve, reject) => {
        CommonService.getBulkUploadCsvLogs()
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

//get sample csv
export const getSampleFile = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getSampleFile()
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                        dispatch(setSampleCsv((response.data && response.data['data']) || []));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

// import Download SOa

export const downloadSoa = async (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.downloadSoa(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getAgencyList = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getAgencyList().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(agencyList(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getPaymentMethodData = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getPaymentMethodData().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const DeleteDocProof = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.deleteDocProof(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                toast.success(response.data.message);
                resolve(response.data)
            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}


